<template>
    <v-btn
        :name="`process[${field.nombre}]`"
        color="success" @click="downloadDocument" 
    >
        {{field.etiqueta}}
        <v-icon small right>fas fa-download</v-icon>
    </v-btn>
</template>

<script>
    import downloadjs from 'downloadjs'
    export default {
        name: "Document",
        props: ['field', 'label'],

        methods: {
            downloadDocument(){
                downloadjs(this.field.value)
            }
        }
    }
</script>